import React, { FC, PropsWithChildren } from 'react';
import { EmptyLayout } from 'layout/empty/empty';
import { Header } from 'common/layout';
import { WhatsappButton } from 'common/whatsapp-button/whatsapp-button';

export const MainLayout: FC<PropsWithChildren<any>> = ({ children, disabledWhatsapp = false, ...props }) => (
  <EmptyLayout>
    <Header {...props} />
    <main className="h-full w-full overflow-auto p-4" id="main-body">
      {children}
    </main>
    {!disabledWhatsapp && <WhatsappButton />}
    <footer className="h-6 bg-primary w-full lg:block hidden" />
  </EmptyLayout>
);
